import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { api } from './services/api';
import planSliceReducer from './slices/planSlice';
import authSliceReducer from './slices/authSlice';
import customizeReducer from './slices/customizeSlice';
import userReducer from './slices/userSlice';
import modalReducer from './slices/modalSlice';
import tagsReducer from './slices/tagsSlice';
import documentsReducer from './slices/documentsSlice';

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  plan: planSliceReducer,
  auth: authSliceReducer,
  customize: customizeReducer,
  user: userReducer,
  modal: modalReducer,
  tags: tagsReducer,
  documents: documentsReducer,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware),
    devTools: true,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
